import React from 'react';
import Banner from '../shared/Banner';
import { useViewport } from '@/hooks/useViewport';

const AboutUsHero: React.FC = () => {
  const { isMobile } = useViewport();

  return (
    <Banner
      height={700}
      className="bg-top"
      backgroundImage="url('/images/banner/about-us-banner.jpg')"
      // backgroundColor="#00000099"
      style={{
        backgroundPosition: isMobile ? 'right -153px center' : undefined
      }}
    >
      <div className="w-full h-full xl:pl-24 pt-20 flex justify-start xl:items-start items-center flex-col"></div>
    </Banner>
  );
};

export default AboutUsHero;
